// MKQ8 ATELIER — Multi-Preset Luxury Theme JS
(function() {
  'use strict';

  // ===== PAGE LOADER =====
  window.addEventListener('load', () => {
    setTimeout(() => {
      const loader = document.querySelector('.page-loader');
      if (loader) loader.classList.add('loaded');
    }, 800);
  });

  document.addEventListener('DOMContentLoaded', function() {

    // ===== CUSTOM CURSOR =====
    const cursor = document.querySelector('.cursor-custom');
    const cursorDot = document.querySelector('.cursor-dot');
    const isMinimal = document.documentElement.classList.contains('preset-minimal');
    const isTouch = 'ontouchstart' in window;

    if (cursor && !isMinimal && !isTouch) {
      let mouseX = 0, mouseY = 0, cursorX = 0, cursorY = 0;
      document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
        if (cursorDot) {
          cursorDot.style.left = mouseX + 'px';
          cursorDot.style.top = mouseY + 'px';
        }
      });
      function animateCursor() {
        cursorX += (mouseX - cursorX) * 0.15;
        cursorY += (mouseY - cursorY) * 0.15;
        cursor.style.left = cursorX + 'px';
        cursor.style.top = cursorY + 'px';
        requestAnimationFrame(animateCursor);
      }
      animateCursor();

      document.querySelectorAll('a, button, .luxury-card, .showcase-tile, .hotspot, input, textarea').forEach(el => {
        el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
        el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
      });
      document.addEventListener('mousedown', () => cursor.classList.add('click'));
      document.addEventListener('mouseup', () => cursor.classList.remove('click'));
    }

    // ===== SCROLL PROGRESS =====
    const progressBar = document.querySelector('.scroll-progress-bar');
    if (progressBar) {
      window.addEventListener('scroll', () => {
        const h = document.documentElement;
        const pct = (h.scrollTop / (h.scrollHeight - h.clientHeight)) * 100;
        progressBar.style.width = pct + '%';
      });
    }

    // ===== STICKY HEADER =====
    const header = document.querySelector('.site-header');
    let lastScroll = 0;
    if (header) {
      window.addEventListener('scroll', () => {
        const current = window.scrollY;
        if (current > 50) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
        lastScroll = current;
      });
    }

    // ===== DRAWERS & OVERLAYS =====
    function openOverlay(selector) {
      const el = document.querySelector(selector);
      const overlay = document.querySelector('.drawer-overlay');
      if (el) el.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeAll() {
      document.querySelectorAll('.drawer-overlay, .cart-drawer-luxury, .quick-view-modal, .search-overlay, .menu-overlay').forEach(el => el.classList.remove('open'));
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openOverlay('.cart-drawer-luxury'); }));
    document.querySelectorAll('[data-search-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openOverlay('.search-overlay'); setTimeout(() => { const inp = document.querySelector('.search-overlay input'); if (inp) inp.focus(); }, 400); }));
    document.querySelectorAll('[data-menu-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openOverlay('.menu-overlay'); }));
    document.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', closeAll));
    const overlay = document.querySelector('.drawer-overlay');
    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

    // ===== QUICK VIEW =====
    document.querySelectorAll('[data-quick-view]').forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        const handle = this.dataset.productHandle;
        if (!handle) return;
        try {
          const res = await fetch(`/products/${handle}.js`);
          const product = await res.json();
          const modal = document.querySelector('.quick-view-modal');
          if (!modal) return;
          modal.querySelector('.qv-image').style.backgroundImage = `url('${product.featured_image}')`;
          modal.querySelector('.qv-vendor').textContent = product.vendor || '';
          modal.querySelector('.qv-title').textContent = product.title;
          modal.querySelector('.qv-price').textContent = formatMoney(product.price);
          const desc = (product.description || '').replace(/<[^>]+>/g, '').substring(0, 240);
          modal.querySelector('.qv-description').textContent = desc + '...';
          const link = modal.querySelector('[data-qv-link]');
          if (link) link.href = product.url;
          openOverlay('.quick-view-modal');
        } catch (err) { console.error(err); }
      });
    });

    // ===== WISHLIST (localStorage) =====
    const wishlist = JSON.parse(localStorage.getItem('mkq8_wishlist') || '[]');
    function syncWishlistUI() {
      document.querySelectorAll('[data-wishlist]').forEach(btn => {
        const id = btn.dataset.productId;
        btn.classList.toggle('active', wishlist.includes(id));
      });
      const count = document.querySelector('[data-wishlist-count]');
      if (count) count.textContent = wishlist.length;
    }
    document.querySelectorAll('[data-wishlist]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const id = this.dataset.productId;
        const i = wishlist.indexOf(id);
        if (i > -1) wishlist.splice(i, 1);
        else wishlist.push(id);
        localStorage.setItem('mkq8_wishlist', JSON.stringify(wishlist));
        syncWishlistUI();
      });
    });
    syncWishlistUI();

    // ===== RECENTLY VIEWED =====
    const productEl = document.querySelector('[data-product-id]');
    if (productEl && document.querySelector('.product-page-luxury')) {
      const recent = JSON.parse(localStorage.getItem('mkq8_recent') || '[]');
      const pid = productEl.dataset.productId;
      const handle = productEl.dataset.productHandle;
      const filtered = recent.filter(p => p.id !== pid).slice(0, 7);
      filtered.unshift({ id: pid, handle: handle, viewed: Date.now() });
      localStorage.setItem('mkq8_recent', JSON.stringify(filtered));
    }

    // ===== HERO SLIDESHOW =====
    const slideshow = document.querySelector('[data-hero-slides]');
    if (slideshow) {
      let current = 0;
      const slides = slideshow.querySelectorAll('.hero-slide');
      const total = slides.length;
      function showSlide(i) {
        current = (i + total) % total;
        slides.forEach((s, idx) => { s.style.opacity = idx === current ? '1' : '0'; s.style.zIndex = idx === current ? '2' : '1'; });
        const counter = document.querySelector('.hero-counter-num');
        if (counter) counter.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
        const bar = document.querySelector('.hero-counter-bar::after');
      }
      slides.forEach((s, i) => { s.style.position = 'absolute'; s.style.inset = '0'; s.style.transition = 'opacity 1s var(--ease-luxury)'; s.style.opacity = i === 0 ? '1' : '0'; });
      slideshow.style.position = 'relative';
      slideshow.style.height = '100vh';
      document.querySelectorAll('[data-hero-prev]').forEach(b => b.addEventListener('click', () => showSlide(current - 1)));
      document.querySelectorAll('[data-hero-next]').forEach(b => b.addEventListener('click', () => showSlide(current + 1)));
      if (total > 1) setInterval(() => showSlide(current + 1), 7000);
    }

    // ===== ACCORDION =====
    document.querySelectorAll('.accordion-header').forEach(h => {
      h.addEventListener('click', function() {
        this.closest('.accordion-item').classList.toggle('open');
      });
    });

    // ===== SWATCH SELECTION =====
    document.querySelectorAll('.option-swatches-lux').forEach(group => {
      group.querySelectorAll('.swatch-lux-color, .swatch-lux-size').forEach(s => {
        s.addEventListener('click', function() {
          group.querySelectorAll('.swatch-lux-color, .swatch-lux-size').forEach(x => x.classList.remove('active'));
          this.classList.add('active');
        });
      });
    });

    // ===== ADD TO CART (AJAX) =====
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', async function(e) {
        e.preventDefault();
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        const original = this.innerHTML;
        this.innerHTML = 'جاري الإضافة...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (res.ok) {
            await refreshCart();
            openOverlay('.cart-drawer-luxury');
            this.innerHTML = '✓ تمت الإضافة';
            setTimeout(() => { this.innerHTML = original; }, 1800);
          } else this.innerHTML = original;
        } catch (err) { this.innerHTML = original; }
      });
    });

    async function refreshCart() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        document.querySelectorAll('[data-cart-total]').forEach(el => el.textContent = formatMoney(cart.total_price));
        updateCartProgress(cart.total_price);
      } catch (err) { console.error(err); }
    }

    function updateCartProgress(total) {
      const threshold = 20000;
      const bar = document.querySelector('.cart-progress-lux .bar-fill');
      const text = document.querySelector('.cart-progress-lux .text');
      if (!bar) return;
      const pct = Math.min((total / threshold) * 100, 100);
      bar.style.width = pct + '%';
      if (text) {
        if (total >= threshold) text.innerHTML = '✦ توصيل مجاني مفتوح';
        else text.innerHTML = `أضف <strong>${formatMoney(threshold - total)}</strong> لتحصل على توصيل مجاني`;
      }
    }

    function formatMoney(cents) {
      return (cents / 1000).toFixed(3) + ' KWD';
    }
    window.formatMoney = formatMoney;

    // ===== QUANTITY CONTROLS =====
    document.querySelectorAll('.cart-qty-lux, .qty-control').forEach(qc => {
      const input = qc.querySelector('input');
      const minus = qc.querySelector('[data-qty-minus]');
      const plus = qc.querySelector('[data-qty-plus]');
      if (minus && input) minus.addEventListener('click', () => { const v = parseInt(input.value) || 1; if (v > 1) input.value = v - 1; });
      if (plus && input) plus.addEventListener('click', () => { input.value = (parseInt(input.value) || 1) + 1; });
    });

    // ===== INTERSECTION OBSERVER (Fade-in on scroll) =====
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -80px 0px' });

    document.querySelectorAll('.section-header, .luxury-card, .showcase-tile, .editorial-split, .editorial-feature, .value-item, .story-block').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(40px)';
      el.style.transition = 'opacity 1.2s var(--ease-luxury), transform 1.2s var(--ease-luxury)';
      observer.observe(el);
    });

    // Stagger value items
    document.querySelectorAll('.values-grid .value-item').forEach((el, i) => { el.style.transitionDelay = (i * 0.15) + 's'; });
    document.querySelectorAll('.products-luxury .luxury-card').forEach((el, i) => { el.style.transitionDelay = (i * 0.1) + 's'; });

    // ===== MARQUEE DUPLICATE =====
    document.querySelectorAll('.marquee-track, .announcement-track').forEach(track => {
      track.innerHTML += track.innerHTML;
    });

    // ===== PARALLAX (subtle on hero) =====
    if (!isTouch) {
      const heroMedia = document.querySelector('.hero-media img');
      window.addEventListener('scroll', () => {
        if (heroMedia) {
          const y = window.scrollY * 0.3;
          heroMedia.style.transform = `translateY(${y}px) scale(1.05)`;
        }
      });
    }

    // ===== SEARCH SUGGESTIONS (live, simple) =====
    const searchInput = document.querySelector('.search-overlay input');
    if (searchInput) {
      let timer;
      searchInput.addEventListener('input', function() {
        clearTimeout(timer);
        const q = this.value.trim();
        const suggBox = document.querySelector('.search-suggestions-results');
        if (!suggBox) return;
        if (q.length < 2) { suggBox.innerHTML = ''; return; }
        timer = setTimeout(async () => {
          try {
            const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5`);
            const data = await res.json();
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            suggBox.innerHTML = products.map(p => `<a href="${p.url}">${p.title}</a>`).join('') || '<p style="opacity:0.5;font-family:var(--font-ui);font-size:13px;letter-spacing:0.2em;text-transform:uppercase;">لا توجد نتائج</p>';
          } catch(e) {}
        }, 300);
      });
    }

    // ===== MENU OVERLAY HOVER (change image) =====
    document.querySelectorAll('.menu-overlay-list a[data-menu-image]').forEach(a => {
      a.addEventListener('mouseenter', function() {
        const img = this.dataset.menuImage;
        const visual = document.querySelector('.menu-overlay-visual');
        if (visual && img) visual.style.backgroundImage = `url('${img}')`;
      });
    });

    // ===== TEXT REVEAL ANIMATION (display-xl titles) =====
    document.querySelectorAll('.text-reveal').forEach(el => {
      const text = el.textContent;
      el.innerHTML = text.split(' ').map(word =>
        `<span style="display:inline-block;overflow:hidden;"><span style="display:inline-block;transform:translateY(100%);transition:transform 1s var(--ease-luxury);">${word}&nbsp;</span></span>`
      ).join('');
      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.querySelectorAll('span span').forEach((s, i) => {
              setTimeout(() => { s.style.transform = 'translateY(0)'; }, i * 80);
            });
            revealObserver.unobserve(e.target);
          }
        });
      });
      revealObserver.observe(el);
    });

  });
})();
